import React, { FC } from 'react';
import styles from './home_client_needs.module.scss';

type Props = {
  personas: Array<{
    picture: {
      url: string;
    };
    type: string;
    text_1: string;
    text_2: string;
    text_3: string;
  }>;
  title: string;
};

export const HomeClientNeeds: FC<Props> = ({ personas, title }) => (
  <div className={styles.container}>
    <h2 className={styles.title}>{title}</h2>
    <div className={styles.tilesContainer}>
      {personas.map(item => (
        <div key={item.picture?.url} className={styles.clientTypeContainer}>
          <img className={styles.clientImage} src={item.picture?.url} />
          <div className={styles.textContainer}>
            <h3 className={styles.clientType}>{item.type}</h3>
            <div className={styles.textItem}>{item.text_1}</div>
            <div className={styles.textItem}>{item.text_2}</div>
            <div className={styles.textItem}>{item.text_3}</div>
          </div>
        </div>
      ))}
    </div>
  </div>
);
